import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Form, Input, Row, Col } from 'antd';
import { observer, inject } from 'mobx-react';
import { formItemLayout } from '../../const/FormConst';

const FormItem = Form.Item;

@inject(
  'deviceInfoStore',
  'deviceInfoMonitorStore',
  'deviceInfoAppStore',
  'deviceInfoDetailStore'
)
@observer
@withRouter
@Form.create()
class DeviceInfoForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const deviceId = this.props.match.params.id;
    if (deviceId) {
      this.props.form.setFieldsValue({ deviceId });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.id !== this.props.match.params.id) {
      const deviceId = nextProps.match.params.id;
      this.props.form.setFieldsValue({ deviceId });
    }
  }

  componentWillUnmount() {
    this.props.form.resetFields();
  }

  handleSubmit() {
    this.props.form.validateFields((error, value) => {
      if (!error) {
        this.props.history.push(`/device/info/${value.deviceId}`);
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row style={{ height: '40px' }}>
          <Col span={6} style={{ height: '40px' }}>
            <FormItem {...formItemLayout} label="设备编号">
              {getFieldDecorator('deviceId', {
                rules: [
                  { required: true, message: '请输入设备编号!' },
                  { pattern: /^[0-9A-F,]*$/, message: '请输入0~9,A~F!' }
                ]
              })(<Input placeholder="请输入设备编号" />)}
            </FormItem>
          </Col>
          <Col span={2} offset={2}>
            <Button type="primary" onClick={this.handleSubmit}>
              搜索
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default DeviceInfoForm;



// WEBPACK FOOTER //
// ./src/components/DeviceInfo/DeviceInfoSearchForm.js